jQuery(document).ready(function ($) {
  // Only allow mega menu to open after page is fully loaded (avoids accidental open during style/layout shift)
  (function setPageLoaded() {
    if (document.readyState === 'complete') {
      document.body.classList.add('page-loaded');
      return;
    }
    window.addEventListener('load', function () {
      document.body.classList.add('page-loaded');
    });
  })();

  function isPageFullyLoaded() {
    return document.body.classList.contains('page-loaded');
  }

  $(document).ready(function () {
    // Blur overlay is owned by showDropdown / hideDropdown below.
    // A separate hover toggle here raced with click handlers and caused
    // the backdrop to flicker off while CSS :hover kept the menu open.

    $('.product-item').on('mouseenter', function () {
      var productIndex = $(this).data('product-index');
      var $megaMenu = $(this).closest('.mega-menu-dropdown');

      $megaMenu.find('.product-item').removeClass('active');
      $(this).addClass('active');

      $megaMenu.find('.features-list-content').removeClass('active');
      $megaMenu.find('.product-features-' + productIndex).addClass('active');

      $megaMenu.find('.features-continued-list-content').removeClass('active');
      $megaMenu.find('.product-features-continued-' + productIndex).addClass('active');

      $megaMenu.find('.product-page-content').removeClass('active');
      $megaMenu.find('.product-page-' + productIndex).addClass('active');
    });
  });

  $(document).ready(function () {
    var $dropdownTriggers = $('.has-dropdown .nav-link');
    var $dropdowns = $('.mega-menu-dropdown');
    var $productItems = $('.product-item');
    var activeDropdown = null;
    var activeTrigger = null;

    // Expose functions globally for nav-link handler
    window.headerDropdownFunctions = {
      showDropdown: showDropdown,
      hideDropdown: hideDropdown,
      getActiveDropdown: function() { return activeDropdown; },
      getActiveTrigger: function() { return activeTrigger; }
    };

    // Listen for custom keyboard event from nav-link handler (fallback)
    // Use unique event name to avoid conflicts with bundle.min.js
    var keyboardEventHandled = false;
    $dropdownTriggers.off('navlinkkeyboard-direct.keyboardnav').on('navlinkkeyboard-direct.keyboardnav', function(e) {
      // Prevent double-handling
      if (keyboardEventHandled) {
        return;
      }
      
      keyboardEventHandled = true;
      var $trigger = e.detail.trigger;
      var $parent = e.detail.parent;
      
      // Check current state before acting
      var currentActiveState = $parent.hasClass('active');
      var isCurrentDropdown = activeDropdown && $parent.find('.mega-menu-dropdown')[0] === activeDropdown[0];
      
      if (isCurrentDropdown) {
        hideDropdown();
      } else if (currentActiveState) {
        hideDropdown();
      } else {
        showDropdown($trigger);
      }
      
      // Reset flag after a short delay
      setTimeout(function() {
        keyboardEventHandled = false;
      }, 100);
    });

    function setMegaMenuBlur(isOpen) {
      $('body').toggleClass('mega-menu-open', isOpen);
      $('.mega-menu-blur-overlay').toggleClass('active', isOpen);
    }

    function showDropdown($trigger) {
      if (!isPageFullyLoaded()) { return; }
      var $parent = $trigger.closest('.has-dropdown');
      var $dropdown = $parent.find('.mega-menu-dropdown');

      $dropdowns.removeClass('active').attr('aria-hidden', 'true');
      $dropdownTriggers.attr('aria-expanded', 'false');
      $('.has-dropdown').removeClass('active');
      // Do not clear blur before re-adding — opacity transition made that flicker.

      $dropdown.addClass('active').attr('aria-hidden', 'false');
      $parent.addClass('active');
      $trigger.attr('aria-expanded', 'true');
      setMegaMenuBlur(true);

      activeDropdown = $dropdown;
      activeTrigger = $trigger;

      var $firstFocusable = $dropdown.find('a, button, [tabindex]:not([tabindex="-1"])').filter(':visible').first();
      if ($firstFocusable.length) {
        $firstFocusable.focus();
      }
    }

    function hideDropdown() {
      $dropdowns.removeClass('active').attr('aria-hidden', 'true');
      $dropdownTriggers.attr('aria-expanded', 'false');
      $('.has-dropdown').removeClass('active');
      activeDropdown = null;
      activeTrigger = null;

      // CSS :hover can still show the mega-menu; keep blur aligned with that.
      setMegaMenuBlur($('.has-dropdown:hover').length > 0);
    }

    $dropdownTriggers.on('click keydown', function (e) {
		var $trigger = $(this);
		var $parent = $trigger.closest('.has-dropdown');

		if (e.type === 'click') {
			// Skip if this was a programmatic click from keyboard (not trusted)
			var originalEvent = e.originalEvent || e;
			if (originalEvent && !originalEvent.isTrusted) {
				return;
			}
			
			e.preventDefault();

			// Pointer is still over the item: CSS :hover keeps the menu open.
			// Closing JS state here would drop the blur while the menu stayed visible.
			if ($parent.is(':hover')) {
				if (!activeDropdown || activeDropdown[0] !== $parent.find('.mega-menu-dropdown')[0]) {
					showDropdown($trigger);
				} else {
					setMegaMenuBlur(true);
				}
				return;
			}

			if (activeDropdown && $parent.find('.mega-menu-dropdown')[0] === activeDropdown[0]) {
				hideDropdown();
				return;
			}

			if ($parent.hasClass('active')) {
				hideDropdown();
			} else {
				showDropdown($trigger);
			}
      	}

      if (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' ')) {
			  // Skip if this was already handled by nav-link handler
			  var originalEvent = e.originalEvent || e;
			  if (originalEvent.handledByNavLink) {
				  return;
			  }
			  
			  e.preventDefault();
			  e.stopPropagation();

        if (activeDropdown && $parent.find('.mega-menu-dropdown')[0] === activeDropdown[0]) {
          hideDropdown();
          return;
        }

        if ($parent.hasClass('active')) {
          hideDropdown();
        } else {
          showDropdown($trigger);
        }
      }
    });

    $dropdownTriggers.on('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault();
        showDropdown($(this));
      }
    });

    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && activeDropdown) {
        hideDropdown();
        if (activeTrigger) {
          activeTrigger.focus();
        }
      }
    });

    $dropdowns.on('keydown', function (e) {
      var $dropdown = $(this);
      var $focusableElements = $dropdown.find('a, button, [tabindex]:not([tabindex="-1"])').filter(':visible');
      var activeElement = document.activeElement;
      var currentIndex = $focusableElements.index(activeElement);

      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (currentIndex === 0 || currentIndex === -1) {
            e.preventDefault();
            hideDropdown();
            if (activeTrigger) {
              activeTrigger.focus();
            }
          }
        } else {
          if (currentIndex === $focusableElements.length - 1 || currentIndex === -1) {
            e.preventDefault();
            hideDropdown();
            
            // Find the next level 1 nav item
            if (activeTrigger && activeTrigger.length) {
              var $currentLevel1 = activeTrigger.closest('.level-1-redesign');
              if ($currentLevel1.length) {
                var $nextLevel1 = $currentLevel1.next('.level-1-redesign');
                if ($nextLevel1.length) {
                  var $nextNavLink = $nextLevel1.find('.nav-link').first();
                  if ($nextNavLink.length) {
                    setTimeout(function() {
                      $nextNavLink.focus();
                    }, 0);
                    return;
                  }
                }
              }
            }
            
            // Fallback: focus back on the trigger
            if (activeTrigger && activeTrigger.length) {
              setTimeout(function() {
                activeTrigger.focus();
              }, 0);
            }
          }
        }
      }
    });

    $productItems.on('keydown', function (e) {
      var $currentItem = $(this);
      var $allItems = $currentItem.siblings().addBack();
      var currentIndex = $allItems.index($currentItem);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var $nextItem = $allItems.eq(currentIndex + 1);
        if ($nextItem.length) {
          $nextItem.focus();
        } else {
          $allItems.first().focus();
        }
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        var $prevItem = $allItems.eq(currentIndex - 1);
        if ($prevItem.length) {
          $prevItem.focus();
        } else {
          $allItems.last().focus();
        }
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        // var $link = $currentItem.find('a');
        // if ($link.length) {
        //   window.location.href = $link.attr('href');
        // }
      } else if (e.key === 'Escape') {
        e.preventDefault();
        hideDropdown();
        if (activeTrigger) {
          activeTrigger.focus();
        }
      }
    });

    $(document).on('click', function (e) {
      if (activeDropdown && !$(e.target).closest('.has-dropdown').length) {
        hideDropdown();
      }
    });

    $dropdownTriggers.on('focus', function () {
      var $trigger = $(this);
      var $parent = $trigger.closest('.has-dropdown');

      $('.has-dropdown').not($parent).removeClass('active');
    });

    $('.has-dropdown').on('mouseenter', function () {
      if (!isPageFullyLoaded()) { return; }
      var $parent = $(this);
      var $trigger = $parent.find('.nav-link');
      var $dropdown = $parent.find('.mega-menu-dropdown');

      if (!activeDropdown || activeDropdown[0] !== $dropdown[0]) {
        showDropdown($trigger);
      } else {
        setMegaMenuBlur(true);
      }
    });

    $('.has-dropdown').on('mouseleave', function () {
      if (activeDropdown && $(this).find('.mega-menu-dropdown')[0] === activeDropdown[0]) {
        setTimeout(function () {
          if (!activeDropdown.is(':hover') && !$(activeTrigger).is(':hover')) {
            hideDropdown();
          }
        }, 100);
      }
    });

    $dropdowns.on('mouseenter', function () {
      if (activeDropdown && activeDropdown[0] === this) {
        return;
      }
    });

    $dropdowns.on('mouseleave', function () {
      if (activeDropdown && activeDropdown[0] === this) {
        setTimeout(function () {
          if (!$(this).is(':hover') && !$(activeTrigger).is(':hover')) {
            hideDropdown();
          }
        }.bind(this), 100);
      }
    });
  });

  var langTriggers = document.querySelectorAll('.tsc-dropdown-menu-trigger');

  langTriggers.forEach(langTrigger => {
    var langWrapper = langTrigger.closest('.tsc-dropdown-menu-wrapper');

    if (langTrigger && langWrapper) {
      langTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        langWrapper.classList.toggle('active');
      });

      document.addEventListener('click', function (e) {
        if (!langWrapper.contains(e.target) && langWrapper.classList.contains('active')) {
          langWrapper.classList.remove('active');
        }
      });
    }
  });

  var langBarClosers = document.querySelectorAll('.ls-close-button');

  langBarClosers.forEach(langBarCloser => {
    var langBar = langBarCloser.closest('.language-switcher');

    if (langBarCloser && langBar) {
      langBarCloser.addEventListener('click', function (e) {
        langBar.classList.add('ls-hide');
        $('.tsc-header-wrapper-redesign').css('top','0');
      });
    }
  });
});

jQuery(document).ready(function ($) {
  // Prevent duplicate initialization
  if (window.mobileMenuInitialized) {
    return;
  }
  window.mobileMenuInitialized = true;
  
    function trapFocus(e) {
    if (!$('.mobile-menu-overlay').hasClass('active')) return;

    var $focusable = $('.mobile-menu-overlay.active').find(
      'a[href], button:not([disabled]), textarea, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    ).filter(':visible');

    if (!$focusable.length) return;

    var firstEl = $focusable[0];
    var lastEl = $focusable[$focusable.length - 1];

    if (e.key === 'Tab') {
      if (e.shiftKey) {
        // Shift+Tab
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
        // Tab
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    }
  }

  // Remove any existing handlers to prevent duplicates (using namespace)
  $('.mobile-menu-button').off('click.mobileMenu keydown.mobileMenu').on('click.mobileMenu keydown.mobileMenu', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
      return;
    }

    if (e.type === 'keydown') {
      e.preventDefault();
    }


    var $overlay = $('.mobile-menu-overlay');
    var isMenuOpen = $overlay.hasClass('active');

    if (isMenuOpen) {
      // Close the menu
      $overlay.removeClass('active');
      $('body').removeClass('mobile-menu-open');
      $('.menu-text').show();
      $('.close-text').hide();
      $('.mobile-menu-main').show();
      $('.mobile-menu-submenu').hide();
      $('.mobile-menu-product-detail').hide();

      // Remove trap
      $(document).off('keydown.trap');
    } else {
      // Open the menu
      // Ensure main menu is visible and submenus are hidden BEFORE opening overlay
      var $mainMenu = $('.mobile-menu-main');
      var $submenu = $('.mobile-menu-submenu');
      var $productDetail = $('.mobile-menu-product-detail');
      
      // Remove hide class from mobile nav items to ensure they're visible
      $('.mobile-nav-item.has-submenu, .mobile-nav-item').removeClass('hide').show();
      
      // Reset menu state - show main, hide submenus
      $submenu.hide();
      $productDetail.hide();
      $mainMenu.show();
      
      // Add active class to overlay
      $overlay.addClass('active');
      $('body').addClass('mobile-menu-open');
      $('.menu-text').hide();
      $('.close-text').show();

      // Add trap
      $(document).on('keydown.trap', trapFocus);

      // Ensure menu is visible after a brief delay to account for CSS transitions
      setTimeout(function () {
        // Remove hide class again to be sure (in case it was added during transition)
        $('.mobile-nav-item.has-submenu, .mobile-nav-item').removeClass('hide').show();
        
        // Force visibility to ensure menu content is shown
        $mainMenu.css({
          'display': 'block',
          'visibility': 'visible'
        });
        
        var $firstItem = $('.mobile-nav-link').first();
        if ($firstItem.length) {
          $firstItem.focus();
        }
      }, 50);
    }
  });

  // Remove any existing handlers to prevent duplicates (using namespace)
  $('.mobile-menu-close').off('click.mobileMenu keydown.mobileMenu').on('click.mobileMenu keydown.mobileMenu', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
      return;
    }

    if (e.type === 'keydown') {
      e.preventDefault();
    }

    $('.mobile-menu-overlay').removeClass('active');
    $('body').removeClass('mobile-menu-open');
    $('.menu-text').show();
    $('.close-text').hide();
    $('.mobile-menu-main').show();
    $('.mobile-menu-submenu').hide();
    $('.mobile-menu-product-detail').hide();

    // Remove trap
    $(document).off('keydown.trap');

    $('.mobile-menu-button').focus();
  });

  // Remove any existing handlers to prevent duplicates (using namespace)
  $('.mobile-back-button').off('click.mobileMenu keydown.mobileMenu').on('click.mobileMenu keydown.mobileMenu', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
      return;
    }

    if (e.type === 'keydown') {
      e.preventDefault();
    }

    if ($('.mobile-menu-product-detail').is(':visible')) {
      $('.mobile-menu-product-detail').hide();
      $('.mobile-menu-submenu').show();
    } else {
      $('.mobile-menu-main').show();
      $('.mobile-menu-submenu').hide();
    }
  });

  // Remove any existing handlers to prevent duplicates (using namespace)
  $('.mobile-nav-link[data-submenu]').off('click.mobileMenu keydown.mobileMenu').on('click.mobileMenu keydown.mobileMenu', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
      return;
    }

    e.preventDefault();
    var submenuType = $(this).data('submenu');

    $('.mobile-menu-main').hide();
    $('.mobile-menu-submenu').show();

    populateMobileSubmenu(submenuType);

    setTimeout(function () {
      var $firstSubmenuItem = $('.mobile-submenu-link').first();
      if ($firstSubmenuItem.length) {
        $firstSubmenuItem.focus();
      }
    }, 100);
  });

  $(document).on('click keydown', '.mobile-submenu-product-link', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
      return;
    }

    e.preventDefault();
    var productData = $(this).data('product');
    var productId = $(this).data('product-id');
    $('.mobile-menu-submenu').hide();
    $('.mobile-menu-product-detail').show();
    populateMobileProductDetail(productData, productId);

    setTimeout(function () {
      var $firstDetailItem = $('.mobile-product-detail-item a, .mobile-product-detail-button').first();
      if ($firstDetailItem.length) {
        $firstDetailItem.focus();
      }
    }, 100);
  });

  function populateMobileSubmenu(submenuType) {
    var $submenuContent = $('.mobile-submenu-content');

    $submenuContent.find('.mobile-submenu-panel').removeClass('active');

    $submenuContent.find('[data-submenu="' + submenuType + '"]').addClass('active');
  }

  function populateMobileProductDetail(productData, productId) {
    var $productDetailContent = $('.mobile-product-detail-content');

    $productDetailContent.find('.mobile-product-detail-panel').removeClass('active');

    if (productId) {
      $productDetailContent.find('[data-product="' + productId + '"]').addClass('active');
    }
  }

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      if ($('.mobile-menu-overlay').hasClass('active')) {
        if ($('.mobile-menu-product-detail').is(':visible')) {
          $('.mobile-menu-product-detail').hide();
          $('.mobile-menu-submenu').show();
          $('.mobile-submenu-link').first().focus();
        } else if ($('.mobile-menu-submenu').is(':visible')) {
          $('.mobile-menu-submenu').hide();
          $('.mobile-menu-main').show();
          $('.mobile-nav-link').first().focus();
        } else {
          $('.mobile-menu-overlay').removeClass('active');
          $('body').removeClass('mobile-menu-open');
          $('.menu-text').show();
          $('.close-text').hide();
          $('.mobile-menu-button').focus();
        }
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // WordPress loads jQuery in noConflict mode; `$` is not global outside jQuery callbacks.
  var $ = jQuery;

  function updateCartCount() {
    try {
      // Get cart count elements
      const cartCountElements = document.querySelectorAll('.cart-count');
      
      if (cartCountElements.length === 0) {
        return;
      }

      let cartSize = 0;
      
      // Get cart_size from sessionStorage
      try {
        const cartSizeValue = sessionStorage.getItem('cart_size');
        
        // If cart_size exists and is not null, empty, or 0, display it
        if (cartSizeValue !== null && cartSizeValue !== '' && cartSizeValue !== '0') {
          cartSize = parseInt(cartSizeValue, 10);
          if (isNaN(cartSize) || cartSize < 0) {
            cartSize = 0;
          }
        }
      } catch (storageError) {
        console.warn('Cart count: sessionStorage not accessible', storageError);
        cartSize = 0;
      }

      // Update all cart count elements
      cartCountElements.forEach(function (element) {
        if (cartSize > 0) {
          element.textContent = String(cartSize);
          element.classList.add('show');
          element.style.display = 'flex';
        } else {
          element.textContent = '0';
          element.classList.remove('show');
          element.style.display = 'none';
        }
      });
    } catch (e) {
      console.error('Error in updateCartCount:', e);
    }
  }

  // Check if cart count is already initialized (e.g., by account.js)
  // Use a global flag to prevent duplicate initialization
  if (!window.cartCountInitialized) {
    // Mark as initialized
    window.cartCountInitialized = true;

    // Initial update
    updateCartCount();

    // Listen for storage changes (cross-tab/window)
    try {
      window.addEventListener('storage', function (e) {
        if (e.key === 'cart_size') {
          updateCartCount();
        }
      });
    } catch (e) {
      console.warn('Cart count: Could not set up storage listener', e);
    }

    // Poll for changes every 100 miliseconds (handles same-tab sessionStorage changes)
    setInterval(updateCartCount, 100);
  } else {
    // Cart count already handled by another script, just do a one-time update
    updateCartCount();
  }

  // General handler for all <a> tags to support Space and Enter
  document.addEventListener('keydown', function (event) {
    if (event.code === 'Space' || event.code === 'Enter') {
      const focused = document.activeElement;

      // Only handle <a> tags
      if (!focused || focused.tagName !== 'A') {
        return;
      }

      // Skip if it's a nav-link (handled by specific handler)
      if (focused.classList.contains('nav-link')) {
        return;
      }

      // Skip if it's inside a product-item (handled by products list handler)
      if (focused.closest('.product-item')) {
        return;
      }

      // Skip if it's a product-item-inner-wrapper (handled by products list handler)
      if (focused.classList.contains('product-item-inner-wrapper')) {
        return;
      }

      // Skip if it's already been handled by another handler
      if (event.defaultPrevented) {
        return;
      }

      // For all other <a> tags, allow Space and Enter to activate them
      event.preventDefault();
      event.stopPropagation();

      // Trigger click to navigate
      if (typeof focused.click === 'function') {
        focused.click();
      } else if (focused.href) {
        // Fallback: navigate directly
        window.location.href = focused.href;
      }
    }
  }, true); // Use capture phase to handle early


	let lastFocusedNavLink = null;
	var globalDropdownFunctions = null; // Will be set by the main dropdown handler

	// Store reference to dropdown functions globally - will be set by jQuery ready
	jQuery(document).ready(function($) {
		// Wait for the main handler to set up functions
		setTimeout(function() {
			if (window.headerDropdownFunctions) {
				globalDropdownFunctions = window.headerDropdownFunctions;
			}
		}, 100);
	});

	document.querySelectorAll('.nav-link').forEach(link => {
		link.addEventListener('click', (e) => {
			lastFocusedNavLink = e.currentTarget;
		});

		link.addEventListener('keydown', (e) => {
			if (e.code === 'Space' || e.code === 'Enter') {
				lastFocusedNavLink = e.currentTarget;
				
				// Check if this is an <a> tag without a dropdown
				var $trigger = jQuery(e.currentTarget);
				var $parent = $trigger.closest('.has-dropdown');
				var hasDropdown = $parent.length > 0 && $parent.find('.mega-menu-dropdown').length > 0;
				var isAnchorTag = e.currentTarget.tagName === 'A';
				
				// If it's an <a> tag without a dropdown, handle navigation for both Space and Enter
				if (isAnchorTag && !hasDropdown) {
					e.preventDefault();
					e.stopImmediatePropagation();
					// Trigger click to navigate (works for both Space and Enter)
					if (typeof e.currentTarget.click === 'function') {
						e.currentTarget.click();
					} else if (e.currentTarget.href) {
						// Fallback: navigate directly
						window.location.href = e.currentTarget.href;
					}
					return;
				}
				
				// For buttons or <a> tags with dropdowns, prevent default and handle dropdown
				e.preventDefault();
				e.stopImmediatePropagation(); // Prevent other handlers on same element from firing
				
				if (globalDropdownFunctions) {
					var currentActiveDropdown = globalDropdownFunctions.getActiveDropdown();
					
					if (currentActiveDropdown && $parent.find('.mega-menu-dropdown')[0] === currentActiveDropdown[0]) {
						globalDropdownFunctions.hideDropdown();
					} else if ($parent.hasClass('active')) {
						globalDropdownFunctions.hideDropdown();
					} else {
						globalDropdownFunctions.showDropdown($trigger);
					}
				} else {
					// Fallback to custom event if functions not ready
					var customEvent = new CustomEvent('navlinkkeyboard-direct', {
						bubbles: false,
						cancelable: true,
						detail: { 
							trigger: $trigger, 
							parent: $parent
						}
					});
					e.currentTarget.dispatchEvent(customEvent);
				}
			}
		}, true); // Use capture phase to handle before other handlers
	});

	document.querySelectorAll('.mega-menu-dropdown').forEach(menu => {
		menu.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				e.preventDefault();
				e.stopPropagation();
				
				// Use global functions to hide dropdown and get active trigger
				if (globalDropdownFunctions) {
					var currentActiveDropdown = globalDropdownFunctions.getActiveDropdown();
					var currentActiveTrigger = globalDropdownFunctions.getActiveTrigger();
					
					// Check if this menu is the active dropdown
					if (currentActiveDropdown && menu === currentActiveDropdown[0]) {
						globalDropdownFunctions.hideDropdown();
						
						// Focus on the trigger that opened this dropdown
						if (currentActiveTrigger && currentActiveTrigger.length) {
							setTimeout(() => {
								currentActiveTrigger.focus();
							}, 0);
						} else if (lastFocusedNavLink) {
							// Fallback to last focused nav link
							setTimeout(() => {
								lastFocusedNavLink.focus();
							}, 0);
						}
					}
				} else {
					// Fallback if functions not available
					if (lastFocusedNavLink) {
						setTimeout(() => {
							lastFocusedNavLink.focus();
						}, 0);
					}
				}
			}
		});
	});

	$('.mega-menu-dropdown .product-item a').on('keydown', function(e) {
		if (e.code === 'Space' || e.code === 'Enter') {
			// Don't prevent default here - let the products list handler manage it
			// This prevents double-handling
			e.stopPropagation();
		}
	});

$('.mega-menu-dropdown .product-item a').on('touchstart', function(e) {
  e.preventDefault();
  e.stopImmediatePropagation();

  var $productItem = $(this).closest('.product-item');
  var $megaMenu = $productItem.closest('.mega-menu-dropdown');

  var productIndex = $productItem.data('product-index');

  if ($productItem.hasClass('active')) {
    window.location.href = $(this).attr('href');
    return;
  }

  $megaMenu.find('.product-item').removeClass('active');
  $productItem.addClass('active');
  $megaMenu.find('.features-list-content, .features-continued-list-content, .product-page-content').removeClass('active');
  $megaMenu.find('.product-features-' + productIndex).addClass('active');
  $megaMenu.find('.product-features-continued-' + productIndex).addClass('active');
  $megaMenu.find('.product-page-' + productIndex).addClass('active');
});

	// This handler is now handled by the products list keyboard navigation
	// Keeping it for backwards compatibility but making it non-conflicting
	$(document).on('keydown', function(e) {
		if (e.code !== 'Space' && e.code !== 'Enter') return;
		var $focused = $(document.activeElement);
		// Only handle if not already handled by products list nav
		if ($focused.hasClass('product-item') && 
		    $focused.closest('.mega-menu-dropdown').length &&
		    !$focused.closest('.products-list').length) {
			e.preventDefault();
			e.stopPropagation();

			var productIndex = $focused.data('product-index');
			var $megaMenu = $focused.closest('.mega-menu-dropdown');

			if ($focused.hasClass('active')) {
			var $link = $focused.find('a').first();
			if ($link.length) {
				window.location.href = $link.attr('href'); // navigate manually
			}
			return;
			}

			$megaMenu.find('.product-item').removeClass('active');
			$focused.addClass('active');
			$megaMenu.find('.features-list-content').removeClass('active');
			$megaMenu.find('.product-features-' + productIndex).addClass('active');
			$megaMenu.find('.features-continued-list-content').removeClass('active');
			$megaMenu.find('.product-features-continued-' + productIndex).addClass('active');
			$megaMenu.find('.product-page-content').removeClass('active');
			$megaMenu.find('.product-page-' + productIndex).addClass('active');
		}
	});

});

/**
 * Keyboard Navigation and Focus Trapping for .products-list
 * Implements accessible keyboard navigation with focus trapping
 */
(function() {
	'use strict';

	/**
	 * Get all focusable elements within a container
	 * @param {HTMLElement} container - The container element
	 * @returns {Array<HTMLElement>} Array of focusable elements
	 */
	function getFocusableElements(container) {
		if (!container) return [];

		var focusableSelectors = [
			'a[href]:not([tabindex="-1"])',
			'button:not([disabled]):not([tabindex="-1"])',
			'textarea:not([disabled]):not([tabindex="-1"])',
			'input:not([disabled]):not([tabindex="-1"])',
			'select:not([disabled]):not([tabindex="-1"])',
			'[tabindex]:not([tabindex="-1"])'
		].join(', ');

		return Array.prototype.slice.call(
			container.querySelectorAll(focusableSelectors)
		).filter(function(element) {
			// Filter out elements that are not visible
			var style = window.getComputedStyle(element);
			return style.display !== 'none' && 
				   style.visibility !== 'hidden' && 
				   style.opacity !== '0';
		});
	}

	/**
	 * Initialize keyboard navigation for a products list
	 * @param {HTMLElement} productsList - The .products-list element
	 */
	function initProductsListKeyboardNav(productsList) {
		if (!productsList) {
			return;
		}

		var productItems = productsList.querySelectorAll('.product-item');
		if (productItems.length === 0) {
			return;
		}

		// Make product-arrow elements NOT directly focusable via Tab
		// They can only receive focus programmatically (via Space/Enter on product-item)
		var productArrows = productsList.querySelectorAll('.product-arrow');
		productArrows.forEach(function(arrow) {
			arrow.setAttribute('tabindex', '-1');
		});

		/**
		 * Set active state on a product item and update related content
		 * @param {HTMLElement} productItem - The product item to activate
		 */
		function setProductItemActive(productItem) {
			if (!productItem) return;

			var productIndex = productItem.getAttribute('data-product-index');
			var megaMenu = productItem.closest('.mega-menu-dropdown');
			
			if (!megaMenu || productIndex === null) return;

			// Remove active class from all product items in this mega menu
			var allProductItems = megaMenu.querySelectorAll('.product-item');
			allProductItems.forEach(function(item) {
				item.classList.remove('active');
			});

			// Add active class to the current product item
			productItem.classList.add('active');

			// Update features and product page content
			var productIndexValue = productIndex;
			megaMenu.querySelectorAll('.features-list-content').forEach(function(content) {
				content.classList.remove('active');
			});
			var featuresContent = megaMenu.querySelector('.product-features-' + productIndexValue);
			if (featuresContent) {
				featuresContent.classList.add('active');
			}

			megaMenu.querySelectorAll('.features-continued-list-content').forEach(function(content) {
				content.classList.remove('active');
			});
			var featuresContinuedContent = megaMenu.querySelector('.product-features-continued-' + productIndexValue);
			if (featuresContinuedContent) {
				featuresContinuedContent.classList.add('active');
			}

			megaMenu.querySelectorAll('.product-page-content').forEach(function(content) {
				content.classList.remove('active');
			});
			var productPageContent = megaMenu.querySelector('.product-page-' + productIndexValue);
			if (productPageContent) {
				productPageContent.classList.add('active');
			}
		}

		/**
		 * Get all focusable elements within the products list
		 * Note: product-arrow elements are NOT included as they should not be directly focusable via Tab
		 * @returns {Array<HTMLElement>} Array of focusable elements
		 */
		function getProductsListFocusableElements() {
			var focusable = [];
			
			// Add all product items (but not product-arrow elements)
			productItems.forEach(function(item) {
				if (item.getAttribute('tabindex') !== '-1') {
					focusable.push(item);
				}
			});

			// Do NOT add product arrows - they should only be focusable programmatically
			// via Space/Enter on product-item

			// Add any other focusable elements within the products list
			var otherFocusable = getFocusableElements(productsList);
			otherFocusable.forEach(function(element) {
				// Only add if it's not already in the list
				if (focusable.indexOf(element) === -1) {
					// Check if it's a product item or arrow
					var isProductItem = element.classList.contains('product-item');
					var isProductArrow = element.classList.contains('product-arrow');
					
					// Skip product arrows - they should not be directly focusable
					if (isProductArrow) {
						return;
					}
					
					// Only add if it's not a child of a product item (to avoid duplicates)
					if (!isProductItem && !element.closest('.product-item')) {
						focusable.push(element);
					}
				}
			});

			return focusable;
		}

		/**
		 * Handle Tab key navigation with focus trapping
		 * @param {KeyboardEvent} event - The keyboard event
		 */
		function handleTabNavigation(event) {
			var focusableElements = getProductsListFocusableElements();
			if (focusableElements.length === 0) return;

			var activeElement = document.activeElement;
			var currentIndex = focusableElements.indexOf(activeElement);
			
			// If current element is a product-arrow, allow Tab to exit the trap
			// Don't prevent default - let the browser handle normal Tab navigation
			if (activeElement.classList.contains('product-arrow')) {
				// Allow normal Tab behavior to exit the trap
				return;
			}
			
			// If current element is not in the list, don't trap
			if (currentIndex === -1) return;

			if (event.shiftKey) {
				// Shift + Tab: move to previous element
				if (currentIndex === 0) {
					// At first element, loop to last
					event.preventDefault();
					event.stopPropagation();
					focusableElements[focusableElements.length - 1].focus();
				}
			} else {
				// Tab: move to next element
				if (currentIndex === focusableElements.length - 1) {
					// At last element, loop to first
					event.preventDefault();
					event.stopPropagation();
					focusableElements[0].focus();
				}
			}
		}

		/**
		 * Handle Enter or Space key on product item
		 * Sets active state and moves focus to the product-arrow element
		 * @param {KeyboardEvent} event - The keyboard event
		 * @param {HTMLElement} productItem - The product item element
		 */
		function handleProductItemActivation(event, productItem) {
			event.preventDefault();
			event.stopPropagation();

			// Set active state (consistent with mouseenter and Tab focus behavior)
			setProductItemActive(productItem);

			// Move focus to the product-arrow element
			var productArrow = productItem.querySelector('.product-arrow');
			if (productArrow) {
				productArrow.focus();
			}
		}

		/**
		 * Handle Enter or Space key on product arrow
		 * Finds the <a> tag with class .product-item-inner-wrapper and opens that link
		 * @param {KeyboardEvent} event - The keyboard event
		 * @param {HTMLElement} productArrow - The product arrow element
		 */
		function handleProductArrowActivation(event, productArrow) {
			event.preventDefault();
			event.stopPropagation();

			// Find the <a> tag with class .product-item-inner-wrapper
			// It should be a parent of the product-arrow
			var parentProductItem = productArrow.closest('.product-item');
			if (parentProductItem) {
				var link = parentProductItem.querySelector('a.product-item-inner-wrapper');
				if (link && link.href) {
					// Log the URL for debugging
					
					// Simulate a click on the link
					link.click();
				} else {
					console.log('No link found with class .product-item-inner-wrapper');
				}
			} else {
				console.log('No parent .product-item found');
			}
		}

		/**
		 * Find the next focusable element outside the products list
		 * @param {HTMLElement} productsList - The products list element
		 * @returns {HTMLElement|null} The next focusable element or null
		 */
		function findNextFocusableOutsideProductsList(productsList) {
			if (!productsList) return null;

			// Get all focusable elements on the page
			var allFocusable = getFocusableElements(document.body);
			
			// Find the last element inside products list to determine where to start looking
			var lastProductItem = null;
			var productItems = productsList.querySelectorAll('.product-item');
			if (productItems.length > 0) {
				lastProductItem = productItems[productItems.length - 1];
			}
			
			// Find the first focusable element that comes after the products list in DOM order
			var foundProductsList = false;
			for (var i = 0; i < allFocusable.length; i++) {
				var element = allFocusable[i];
				
				// Track when we're inside the products list
				if (productsList.contains(element)) {
					foundProductsList = true;
					continue;
				}
				
				// Skip if element is a product-arrow (shouldn't be focusable)
				if (element.classList.contains('product-arrow')) {
					continue;
				}
				
				// If we've passed the products list, return this element
				if (foundProductsList && !productsList.contains(element)) {
					return element;
				}
			}
			
			// If no element found after products list, try to find focusable elements 
			// in the mega menu but outside products list
			var megaMenu = productsList.closest('.mega-menu-dropdown');
			if (megaMenu) {
				var megaMenuFocusable = getFocusableElements(megaMenu);
				for (var j = 0; j < megaMenuFocusable.length; j++) {
					var elem = megaMenuFocusable[j];
					if (!productsList.contains(elem) && 
						!elem.classList.contains('product-arrow') &&
						elem.getAttribute('tabindex') !== '-1') {
						return elem;
					}
				}
			}
			
			// Fallback: find any focusable element outside products list
			for (var k = 0; k < allFocusable.length; k++) {
				var el = allFocusable[k];
				if (!productsList.contains(el) && 
					!el.classList.contains('product-arrow')) {
					return el;
				}
			}
			
			return null;
		}

		// Handle focus events to set active state when Tab navigates to a product item
		productsList.addEventListener('focusin', function(event) {
			var target = event.target;
			if (target.classList.contains('product-item')) {
				// Only set active if it doesn't already have the active class
				// This prevents unnecessary updates when focus moves within an already active item
				if (!target.classList.contains('active')) {
					setProductItemActive(target);
				}
			}
		});

		// Use event delegation on the products list
		productsList.addEventListener('keydown', function(event) {
			var target = event.target;
			var activeElement = document.activeElement;
			var isProductItem = target.classList.contains('product-item') || activeElement.classList.contains('product-item');
			var isProductArrow = target.classList.contains('product-arrow') || activeElement.classList.contains('product-arrow');
			var activeIsProductArrow = activeElement.classList.contains('product-arrow');

			// Handle Tab key
			if (event.key === 'Tab') {
				// If Tab is pressed and focus is on a product-arrow, move focus to features column
				if (activeIsProductArrow && !event.shiftKey) {
					event.preventDefault();
					event.stopPropagation();

					// Get the product item that contains this arrow
					var parentProductItem = activeElement.closest('.product-item');
					if (!parentProductItem) {
						return;
					}

					// Get the product index
					var productIndex = parentProductItem.getAttribute('data-product-index');
					if (productIndex === null) {
						return;
					}

					// Find the mega menu
					var megaMenu = productsList.closest('.mega-menu-dropdown');
					if (!megaMenu) {
						return;
					}

					// Find the features column (second column)
					var featuresColumn = megaMenu.querySelector('.features-column');
					if (!featuresColumn) {
						return;
					}

					// Find the active features list for this product index
					var activeFeaturesList = featuresColumn.querySelector('.features-list-content.product-features-' + productIndex + '.active');
					if (!activeFeaturesList) {
						// Try without active class in case it's not set
						activeFeaturesList = featuresColumn.querySelector('.features-list-content.product-features-' + productIndex);
					}

					if (!activeFeaturesList) {
						return;
					}

					// Helper: find the first focusable element inside a container
					function findFirstFocusableIn(container) {
						if (!container) return null;

						var focusables = getFocusableElements(container); // your existing helper

						for (var i = 0; i < focusables.length; i++) {
							var el = focusables[i];
							// Skip product arrows and elements with tabindex="-1"
							if (!el.classList.contains('product-arrow') && el.getAttribute('tabindex') !== '-1') {
								return el;
							}
						}
						return null;
					}

					// Find the first focusable element in the active features list
					var nextElement = findFirstFocusableIn(activeFeaturesList);

					if (nextElement) {
						nextElement.focus();
					}
					return;
				}

				
				// If Shift+Tab is pressed and focus is on a product-arrow, move focus back to its parent product-item
				if (activeIsProductArrow && event.shiftKey) {
					event.preventDefault();
					event.stopPropagation();
					
					var parentProductItem = activeElement.closest('.product-item');
					if (parentProductItem) {
						parentProductItem.focus();
					}
					return;
				}
				
				// Handle focus trapping for product items and other elements
				// Tab on product-item should move to next product-item (not to product-arrow)
				// Only trap if focus is NOT on a product-arrow
				if (productsList.contains(activeElement) && !activeIsProductArrow) {
					handleTabNavigation(event);
				}
				return;
			}

			// Handle Enter or Space on product item
			// Only Space/Enter should move focus to product-arrow (not Tab)
			if ((event.key === 'Enter' || event.key === ' ') && isProductItem) {
				var productItem = activeElement.classList.contains('product-item') ? activeElement : target.closest('.product-item');
				if (productItem) {
					handleProductItemActivation(event, productItem);
				}
				return;
			}

			// Handle Enter or Space on product arrow
			if ((event.key === 'Enter' || event.key === ' ') && isProductArrow) {
				var productArrow = activeElement.classList.contains('product-arrow') ? activeElement : target.closest('.product-arrow');
				if (productArrow) {
					handleProductArrowActivation(event, productArrow);
				}
				return;
			}
		});


    var productArrows = productsList.querySelectorAll('.product-arrow');

    productArrows.forEach(arrow => {
        arrow.addEventListener('keydown', function(event) {
            // Handle Enter or Space on product arrow
            if ((event.key === 'Enter' || event.key === ' ')) {
                var link = arrow.closest('a.product-item-inner-wrapper');
                if (link && link.href) {
                  link.click();
                }
                // handleProductArrowActivation(event, target);
                return;
            }
        });
    });

    
	}

	/**
	 * Initialize keyboard navigation for all products lists on the page
	 */
	function initAllProductsLists() {
		var productsLists = document.querySelectorAll('.products-list');
		productsLists.forEach(function(productsList) {
			initProductsListKeyboardNav(productsList);
		});
	}

	// Initialize when DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAllProductsLists);
	} else {
		initAllProductsLists();
	}

	// Re-initialize if new products lists are added dynamically
	var observer = new MutationObserver(function(mutations) {
		mutations.forEach(function(mutation) {
			mutation.addedNodes.forEach(function(node) {
				if (node.nodeType === 1) { // Element node
					// Check if the added node is a products list
					if (node.classList && node.classList.contains('products-list')) {
						initProductsListKeyboardNav(node);
					}
					// Check if a products list was added within this node
					var productsLists = node.querySelectorAll && node.querySelectorAll('.products-list');
					if (productsLists) {
						productsLists.forEach(function(productsList) {
							initProductsListKeyboardNav(productsList);
						});
					}
				}
			});
		});
	});

	// Observe the document body for changes
	if (document.body) {
		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
	}
})();

/**
 * Update signin/signout links with current page URL parameter,
 * and resolve mega-menu __CURRENT_PATH__ placeholders (REST embeds).
 */
(function () {
  'use strict';

  var CURRENT_PATH_PLACEHOLDER = '__CURRENT_PATH__';

  // Get current page path (empty pathname → root, matching PHP fallback)
  var currentPageUrl = window.location.pathname || '/';

  /**
   * Replace the signin/signout links href to include current page URL as ?p parameter
   */
  function replaceSigninSignoutLinks() {
      // Target the <a> element inside .sign-in-status-2
      var signinLink = document.querySelector('.sign-in-status-2 a, .sign-in-status-2 .account-button');
      if (signinLink && signinLink.href) {
          try {
              var signinUrl = new URL(signinLink.href);
              signinUrl.searchParams.set('p', currentPageUrl);
              signinLink.href = signinUrl.toString();
          } catch (e) {
              // If URL parsing fails, append parameter manually
              var separator = signinLink.href.indexOf('?') !== -1 ? '&' : '?';
              signinLink.href = signinLink.href + separator + 'p=' + encodeURIComponent(currentPageUrl);

              console.warn('Account: unable to parse signin URL', e);
          }
      }
      
      // Target the <a> element inside .sign-out-status-2
      var signoutLink = document.querySelector('.sign-out-status-2 a, .sign-out-status-2 .account-button');
      if (signoutLink && signoutLink.href) {
          try {
              var signoutUrl = new URL(signoutLink.href);
              signoutUrl.searchParams.set('p', currentPageUrl);
              signoutLink.href = signoutUrl.toString();
          } catch (e) {
              // If URL parsing fails, append parameter manually
              var separator = signoutLink.href.indexOf('?') !== -1 ? '&' : '?';
              signoutLink.href = signoutLink.href + separator + 'p=' + encodeURIComponent(currentPageUrl);

              console.warn('Account: unable to parse signout URL', e);
          }
      }
  }

  /**
   * Replace __CURRENT_PATH__ in mega menu / ACF links with the browser path.
   * Needed when nav HTML comes from REST (server cannot know the other platform URL).
   */
  function replaceCurrentPathPlaceholders() {
      var encodedPath = encodeURIComponent(currentPageUrl);
      var links = document.querySelectorAll('a[href*="' + CURRENT_PATH_PLACEHOLDER + '"]');

      for (var i = 0; i < links.length; i++) {
          var link = links[i];
          var hrefAttr = link.getAttribute('href');
          if (!hrefAttr || hrefAttr.indexOf(CURRENT_PATH_PLACEHOLDER) === -1) {
              continue;
          }
          link.setAttribute('href', hrefAttr.split(CURRENT_PATH_PLACEHOLDER).join(encodedPath));
      }
  }

  function replaceDynamicPathLinks() {
      replaceSigninSignoutLinks();
      replaceCurrentPathPlaceholders();
  }

  // Initialize when DOM is ready
  function init() {
      // Try immediately
      replaceDynamicPathLinks();

      // Also try after a short delay in case header HTML is loaded dynamically
      setTimeout(replaceDynamicPathLinks, 100);
      setTimeout(replaceDynamicPathLinks, 500);
      setTimeout(replaceDynamicPathLinks, 1000);
  }

  if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
  } else {
      init();
  }
})();

/**
 * Cart modal functionality
 * Shows cart modal when add-to-cart button is clicked
 */
(function () {
  'use strict';

  /**
   * Move the mobile cart modal to immediately follow .ub-emb-container when present so
   * stacking order matches other late-injected overlays (e.g. Unbounce embed).
   * @returns {boolean} True when relocation ran or modal was already in place.
   */
  function relocateMobileCartModalAfterUbEmb() {
    var mobileCartModal = document.querySelector('.tsc-cart-header-navigation-modal-mobile');
    var ubEmb = document.querySelector('.ub-emb-container');
    if (!mobileCartModal || !ubEmb || !ubEmb.parentNode) {
      return false;
    }
    if (mobileCartModal.previousElementSibling === ubEmb) {
      return true;
    }
    ubEmb.parentNode.insertBefore(mobileCartModal, ubEmb.nextSibling);
    return true;
  }

  function setupMobileCartModalUbEmbRelocation() {
    if (relocateMobileCartModalAfterUbEmb()) {
      return;
    }
    if (!document.querySelector('.tsc-cart-header-navigation-modal-mobile')) {
      return;
    }
    var observer = new MutationObserver(function () {
      if (relocateMobileCartModalAfterUbEmb()) {
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 15000);
  }

  /**
   * Theme cart-modal checkout CTAs from the browser path.
   * Store embeds bake button classes at REST render time; without return_url
   * they default to Camtasia green. Match /store/snagit client-side like
   * __CURRENT_PATH__ resolution.
   */
  function themeCartModalCheckoutButtons() {
    var path = (window.location.pathname || '/').toLowerCase();
    var isSnagitStore = path.indexOf('/store/snagit') !== -1;
    var isCamtasiaStore = path.indexOf('/store/camtasia') !== -1;
    var buttonIds = [
      'cart-modal-checkout-button',
      'cart-modal-checkout-button-mobile'
    ];

    for (var i = 0; i < buttonIds.length; i++) {
      var button = document.getElementById(buttonIds[i]);
      if (!button) {
        continue;
      }
      if (isSnagitStore) {
        button.classList.remove('button-style-green', 'is-camtasia-store-v1');
        button.classList.add('button-style-pink', 'is-snagit-store-v1');
      } else if (isCamtasiaStore) {
        button.classList.remove('button-style-pink', 'is-snagit-store-v1');
        button.classList.add('button-style-green', 'is-camtasia-store-v1');
      }
    }
  }

  function showCartModal() {
    // Check if cart_size exists in sessionStorage and is > 0
    try {
      var cartSizeValue = sessionStorage.getItem('cart_size');
      var cartSize = 0;
      
      if (cartSizeValue !== null && cartSizeValue !== '' && cartSizeValue !== '0') {
        cartSize = parseInt(cartSizeValue, 10);
        if (isNaN(cartSize) || cartSize < 0) {
          cartSize = 0;
        }
      }
      
      // Only show modal if cart has items
      if (cartSize <= 0) {
        return;
      }
    } catch (storageError) {
      // If sessionStorage is not accessible, don't show modal
      console.warn('Cart modal: sessionStorage not accessible', storageError);
      return;
    }

    themeCartModalCheckoutButtons();
    
    var cartModal = document.querySelector('.tsc-cart-header-navigation-modal');
    if (cartModal) {
      cartModal.classList.add('open');
      
      // Focus the checkout button for keyboard accessibility
      var checkoutButton = document.getElementById('cart-modal-checkout-button');
      if (checkoutButton) {
        // Remove tabindex to make it focusable
        checkoutButton.removeAttribute('tabindex');
        // Focus the button after a short delay to ensure modal is visible
        setTimeout(function() {
          checkoutButton.focus();
        }, 100);
      }
    }

    // Mobile-only modal support (kept separate from desktop logic).
    relocateMobileCartModalAfterUbEmb();
    var mobileCartModal = document.querySelector('.tsc-cart-header-navigation-modal-mobile');
    if (mobileCartModal && window.matchMedia('(max-width: 768px)').matches) {
      mobileCartModal.classList.add('open');

      var mobileCheckoutButton = document.getElementById('cart-modal-checkout-button-mobile');
      if (mobileCheckoutButton) {
        mobileCheckoutButton.removeAttribute('tabindex');
      }
      setTimeout(function() {
        if (mobileCheckoutButton) {
          mobileCheckoutButton.focus();
        }
      }, 100);
      
      // Auto-hide after 5 seconds - TO BE CONFIRMED BY THE CLIENT
      // setTimeout(function() {
      //   cartModal.classList.remove('open');
      //}, 5000);
    }
  }

  function handleAddToCartClick(e) {
    // Show modal after 1 second delay
    setTimeout(function() {
      showCartModal();
    }, 1000);
  }

  // Initialize cart modal functionality
  function initCartModal() {
    // Listen for clicks on add-to-cart elements
    document.addEventListener('click', function(e) {
      var addToCartElement = e.target.closest('.add-to-cart');
      if (addToCartElement) {
        handleAddToCartClick(e);
      }
    });

    // Listen for keyboard events (Enter and Space keys) on Buy Now buttons
    document.addEventListener('keydown', function(e) {
      // Check if Enter or Space key is pressed
      if (e.key === 'Enter' || e.keyCode === 13) {
        var target = e.target;
        // Check if the target is a Buy Now button or inside one
        var buyNowButton = target.closest('.button-buy-now, .add-to-cart, [data-menu-text*="buy"], [data-menu-text*="Buy"]');
        if (buyNowButton) {
          e.preventDefault();
          handleAddToCartClick(e);
        }
      }
    });

    // Close modal when clicking outside
    document.addEventListener('click', function(e) {
      var cartModal = document.querySelector('.tsc-cart-header-navigation-modal');
      var mobileCartModal = document.querySelector('.tsc-cart-header-navigation-modal-mobile');
      var cartListItem = document.querySelector('.menu-ctas .cart');
      
      if (cartModal && cartModal.classList.contains('open')) {
        // Don't close if clicking inside cart area or modal
        if (!cartListItem || !cartListItem.contains(e.target)) {
          if (!cartModal.contains(e.target)) {
            cartModal.classList.remove('open');
            // Reset tabindex when modal closes
            var checkoutButton = document.getElementById('cart-modal-checkout-button');
            if (checkoutButton) {
              checkoutButton.setAttribute('tabindex', '-1');
            }
          }
        }
      }

      if (mobileCartModal && mobileCartModal.classList.contains('open')) {
        if (!mobileCartModal.contains(e.target)) {
          mobileCartModal.classList.remove('open');
          var mobileCheckoutButton = document.getElementById('cart-modal-checkout-button-mobile');
          if (mobileCheckoutButton) {
            mobileCheckoutButton.setAttribute('tabindex', '-1');
          }
        }
      }
    });

    // Handle Escape key to close modal
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        var cartModal = document.querySelector('.tsc-cart-header-navigation-modal');
        var mobileCartModal = document.querySelector('.tsc-cart-header-navigation-modal-mobile');
        if (cartModal && cartModal.classList.contains('open')) {
          cartModal.classList.remove('open');
          // Reset tabindex when modal closes
          var checkoutButton = document.getElementById('cart-modal-checkout-button');
          if (checkoutButton) {
            checkoutButton.setAttribute('tabindex', '-1');
          }
        }

        if (mobileCartModal && mobileCartModal.classList.contains('open')) {
          mobileCartModal.classList.remove('open');
          var mobileCheckoutButton = document.getElementById('cart-modal-checkout-button-mobile');
          if (mobileCheckoutButton) {
            mobileCheckoutButton.setAttribute('tabindex', '-1');
          }
        }
      }
    });

    // Handle Space and Enter keys on checkout button
    document.addEventListener('keydown', function(e) {
      var checkoutButton = document.getElementById('cart-modal-checkout-button');
      var mobileCheckoutButton = document.getElementById('cart-modal-checkout-button-mobile');
      var activeElement = document.activeElement;
      var isCheckoutButtonFocused = activeElement && (activeElement === checkoutButton || activeElement === mobileCheckoutButton);
      var activeModal = activeElement ? activeElement.closest('.tsc-cart-header-navigation-modal') : null;
      var isOpenCartModalContext = activeModal && activeModal.classList.contains('open');

      if (isCheckoutButtonFocused && isOpenCartModalContext) {
        if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
          e.preventDefault();
          e.stopPropagation();
          // Trigger click on the button
          if (typeof activeElement.click === 'function') {
            activeElement.click();
          }
        }
      }
    });

    // Handle Space and Enter keys on cart buttons
    document.addEventListener('keydown', function(e) {
      var activeElement = document.activeElement;
      if (activeElement && activeElement.classList.contains('cart-button')) {
        if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
          e.preventDefault();
          e.stopPropagation();
          // Trigger click on the button
          if (typeof activeElement.click === 'function') {
            activeElement.click();
          }
        }
      }
    });

    // Prevent modal from closing when clicking inside cart area
    var cartListItem = document.querySelector('.menu-ctas .cart');
    if (cartListItem) {
      cartListItem.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }

    setupMobileCartModalUbEmbRelocation();
    themeCartModalCheckoutButtons();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartModal);
  } else {
    initCartModal();
  }
})();
